import { getCourtByCountryCode, } from '@debbie/common/dist/court/index.js';
import { addressToString } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../../utils/errors.js';
import Button from '../../Button.js';
import ButtonGroup from '../../ButtonGroup.js';
import SearchInput from '../../SearchInput.js';
import Well from '../../Well.js';
import UserInfoEntity from './UserInfoEntity.js';
const UserCourt = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const [courtId, setCourtId] = useState(null);
    const patchCourtId = useMutation((courtId) => props.patchUser({ courtId }), {
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.party),
    });
    useEffect(() => {
        if (details) {
            if (!courtId && details.courtId) {
                setCourtId(details.courtId);
            }
        }
    }, [details]);
    const courts = getCourtByCountryCode(tenant?.countryCode);
    if (!courts) {
        return null;
    }
    return props.user.relation !== 'alternative-contact' ? (React.createElement(UserInfoEntity, { title: lang.debtorInfo.jurisdiction, value: details.courtId, onChange: (val) => { }, hist: details.courtIdHist, renderValue: (courtId) => {
            const court = courtId && courts.find((c) => c.id === courtId);
            return ((court && court.name) || (React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noJurisdiction)));
        }, renderEditor: (selectedValue) => (React.createElement(Well, null,
            React.createElement(SearchInput, { placeholder: lang.debtorInfo.chooseJurisdiction, searchAll: (q) => {
                    return courts
                        .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) !== -1)
                        .map((c) => ({
                        key: c.id,
                        heading: c.name,
                        subheading: addressToString(c),
                        returnData: c.id,
                    }));
                }, static: (() => {
                    const court = courtId && courts.find((c) => c.id === courtId);
                    return court && court.name;
                })(), onRemoveStatic: () => setCourtId(null), onSelect: setCourtId, searchDelay: 0, forceOpen: true }),
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { disabled: !courtId, loading: patchCourtId.isLoading, onClick: () => {
                        courtId && selectedValue(courtId);
                        patchCourtId.mutate(courtId);
                    }, size: "small" }, lang.debtorInfo.save),
                React.createElement(Button, { theme: "secondary", loading: patchCourtId.isLoading, onClick: () => {
                        selectedValue(null);
                        patchCourtId.mutate(null);
                    }, size: "small" }, lang.debtorInfo.remove)))), removable: true })) : null;
};
export default UserCourt;
//# sourceMappingURL=UserCourt.js.map